export const getAuthConfig = () => {
  const authDomain = import.meta.env.VITE_AUTH_DOMAIN;
  const authClientId = import.meta.env.VITE_AUTH_CLIENT_ID;
  const audience = import.meta.env.VITE_AUTH_API_ORIGIN;
  const appOrigin = import.meta.env.VITE_AUTH_APP_ORIGIN;
  const organization = import.meta.env.VITE_AUTH_ORGANIZATION;
  const connection = import.meta.env.VITE_AUTH_CONNECTION;
  return {
    domain: authDomain,
    clientId: authClientId,
    audience: audience,
    appOrigin: appOrigin,
    apiOrigin: audience,
    organization: organization,
    connection: connection,
  };
};
